export default __webpack_public_path__ + "static/media/hrlogo.24e9a8a8.svg";